import React from 'react';
import * as R from 'ramda';
import { navigate } from 'gatsby';
import { MEMBER_CARD, APPLY, MY_ACCOUNT, LOGOUT } from '../../../constants/menu';
import { MemberCardIcon, ApplyIcon, AccountIcon, LogoutIcon } from './Icons';
import { AUTH_TOKEN } from '../../../constants';

const applyOption = {
  name: 'Apply',
  value: APPLY,
  icon: <ApplyIcon />,
};

const memberCardOption = {
  name: 'Member Card',
  value: MEMBER_CARD,
  icon: <MemberCardIcon />,
};

const userOptions = [
  {
    name: 'My Account',
    value: MY_ACCOUNT,
    icon: <AccountIcon />,
  },
  {
    name: 'Logout',
    value: LOGOUT,
    icon: <LogoutIcon />,
  },
];

const ROLES = {
  OWNER: 'owner',
  DOCTOR: 'doctor',
  MEMBER: 'member',
  DRUG_SUPPLIER: 'drug_supplier',
};

export const getUserOptions = user => {
  switch (R.prop('role', user)) {
    case ROLES.MEMBER:
      return [].concat(memberCardOption, userOptions);
    case ROLES.DOCTOR:
      return [].concat(applyOption, userOptions);
    default:
      return userOptions;
  }
};

const logout = () => {
  localStorage.removeItem(AUTH_TOKEN);
  window.location.assign('/public');
};

export const clickUserOption = option => {
  switch (R.prop('value', option)) {
    case MEMBER_CARD:
      return navigate('/member-only/member-card');
    case MY_ACCOUNT:
      return window.open('https://app.cowsquare.com/');
    case APPLY:
      return navigate('/public/apply');
    case LOGOUT:
      logout();
      return;
    default:
      return;
  }
};
